import { Component, Inject, OnInit, QueryList, ViewChildren } from '@angular/core';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { forkJoin, map, Observable } from 'rxjs';
import { MweConstants } from 'src/app/constants/mwe-constants.service';
import { Enquiry } from 'src/app/models/messaging-models';
import { Product } from 'src/app/models/product-model';
import { ApiResponseModel } from 'src/app/models/shared-model';
import { LocalStorageService } from 'src/app/services/local-storage.service'; 
import { ProductsService } from 'src/app/services/products.service';
import { SweetAlertService } from 'src/app/services/sweetalert.service';
import { WebsocketService } from 'src/app/services/websocket.service';
import { FileUploadService } from 'src/app/services/shared/file-upload.service';
import { AuthService } from 'src/app/services/auth.service';
import { MasterDataService } from 'src/app/services/master-data.service';
import { OemService } from 'src/app/services/oem/oem.service';
import Swal from 'sweetalert2';
import { MatAutocompleteTrigger } from '@angular/material/autocomplete';
import { DistributorService } from 'src/app/services/distributor/distributor.service';
import { EndCustomerService } from 'src/app/services/end-customer.service';

@Component({
  selector: 'app-enquiry',
  templateUrl: './enquiry.component.html',
  styleUrls: ['./enquiry.component.scss']
})

export class EnquiryComponent implements OnInit {
  enquiryForm!: FormGroup;
  organisationInfoForm: any;
  productId: string = '';
  receiver1Id: any;
  receiver2Id : any;
  allDistributorIdofProduct: any;
  filteredDistributorIds: any = [];
  distributorIds:any;
  id: any;
  oemData: any;
  image: File | null = null;
  selectedFile: boolean = false;
  showImage:string | undefined;
  countries: any;
  customCountry: string = '';
  countryCodes: any[] = [];
  filteredCountryCodes: any[] = [];
  searchControl = new FormControl('');
  showDropdown: boolean = false;
  reciever1Id: string = '';
  reciever2Id: string = '';
  senderId: string = '';
  prodData: any;
  productInfoId: any;
  restrict: boolean = false;
  userDetails: any;
  isDragOver = false;
  userDetailsById: any = '';
  userId: string = '';
  messageTooLong: boolean = false;
  [x: string]: any;
  states:any;
  stateDropdown: any =[];
  countryDropdown: any =[];
  country:any=[];
  state:any=[];
  countryFromIp:any=[];
  stateFromIp:any=[];
  filteredCountries: any = [];
  filteredStates: any = [];
  user:any =[];
  @ViewChildren(MatAutocompleteTrigger) autoCompletes!: QueryList<MatAutocompleteTrigger>;

  constructor(private fb: FormBuilder,
    private websocketService: WebsocketService,
    private localStorageService: LocalStorageService,
    private productsService: ProductsService,
    private route: ActivatedRoute,
    private sweetAlertService: SweetAlertService,
    private fileUploadService: FileUploadService,
    private authService : AuthService,
    private masterDataService: MasterDataService,
    private oemService: OemService,
    private distributorService: DistributorService,
    private endCustomerService: EndCustomerService,
    private router: Router
  ) {
    this.localStorageService.getUserDetails().subscribe(userDetails => {
      this.userId = userDetails.userId;
    });
    window.addEventListener('scroll', this.scrollEvent, true);
  }

  scrollEvent = (event: any): void => {
    const target = event.target as HTMLElement
    const isScrollingInsidePanel = this.autoCompletes.some(autoComplete => {
      if(autoComplete.panelOpen){
        const panel = autoComplete.autocomplete.panel;
        return panel && panel.nativeElement.contains(target);
      }
      return false;
    })
    if(!isScrollingInsidePanel){
      this.closePanels();
    }
   };

   closePanels(){
    this.autoCompletes.forEach(autoComplete =>{
      if(autoComplete.panelOpen){
        autoComplete.closePanel();
      }
    })
  }

  ngOnInit(): void {
    this.productId = this.route.snapshot.params['id'];
    if(localStorage.getItem('roleName') === 'OEM'){
      this.id = localStorage.getItem('oemId');
      this.user =this.oemService.getOEMById(this.id);
    } else if(localStorage.getItem('roleName') === 'DISTRIBUTOR'){
      this.id = localStorage.getItem('distributorId');
      this.user =this.distributorService.getDistributorById(this.id);
    } else if(localStorage.getItem('roleName') === 'USER'){
      this.id = localStorage.getItem('userId');
      this.user =this.endCustomerService.getEndCustomerdetails(this.id);
    }
    this.initializeenquiryFrom();
    this.getUserDetailsById(this.user);
    this.getCountriesData();    
    this.getCurrentLocation();
   
    this.websocketService.joinChat(this.id);
    this.getCountryCodes();
    this.searchControl.valueChanges.subscribe((term) => {
      this.filterCountryCodes(term ?? '');
    });    

  }
  getCountriesData() {
    this.masterDataService.getCountries(0, 250, '', []).subscribe((res=>{
      if(res && res.data.length !== 0) {
        this.countryDropdown = res.data;
        this.filteredCountries = this.countryDropdown;    
      } else if(!res.data || res.data.length === 0) {
        this.countryDropdown = [];
       
        this.filteredCountries = this.countryDropdown;

      }
    }), err => {
      this.countryDropdown = [];
      this.filteredCountries = this.countryDropdown;

    })
  }

  getStatesDataWithCountryName(event: any) {
    const value = event.option.value;
    if (value !== undefined && value !== "" && value !== null) {
      this.enquiryForm?.get('state')?.setValue('');
    }
    const countryName = (this.enquiryForm?.get('country')?.value) ? this.enquiryForm?.get('country')?.value : []    
    this.masterDataService.getStates(0, 500, '', [countryName] )?.subscribe((res => {
      if(res?.data && res?.data.length !== 0) {  
        
        this.stateDropdown = res.data; 
        this.filteredStates=this.stateDropdown;
        if(this.state !== "") {
          let search = this.enquiryForm?.get('state')?.value || ''
          this.filteredStates = this.stateDropdown.filter((d: any) => d.stateName.toLowerCase().includes(search.toLowerCase()));
        }
      } else if(!res.data || res.data.length === 0 ) {
        this.stateDropdown = [];
        this.filteredStates=this.stateDropdown;
      }
    }), err => {
      this.stateDropdown = [];
      this.filteredStates=this.stateDropdown;
    }
  )
  }

  searchCountry(event: any) {
    let search = event.target.value
    if(search === "" || search === null || search === undefined) {
    } else if(search) {
      this.enquiryForm?.get('state')?.reset();
      this.filteredCountries = this.countryDropdown.filter((d: any) => d.countryName.toLowerCase().includes(search.toLowerCase()));
    } 
  }
  searchState(event: any) {
    let search = event.target.value
    if(search === "" || search === null || search === undefined) {
    } else if(search) {   
      this.masterDataService.getStates(0, 500, '', [(this.enquiryForm.get('country') as FormControl).value] )?.subscribe((res => {
        if(res?.data && res?.data.length !== 0) {  
          this.stateDropdown = res.data; 
          this.filteredStates = this.stateDropdown.filter((d: any) => d.stateName.toLowerCase().includes(search.toLowerCase()));
        } 
    }))}
  }

  getCurrentLocation(): void {
  if (navigator.geolocation) {
    navigator.geolocation.getCurrentPosition(
        (position) => {
        const lat=position.coords.latitude;
        const lng=position.coords.longitude;
        const url = `https://nominatim.openstreetmap.org/reverse?format=json&lat=${lat}&lon=${lng}`;
  
    return fetch(url)
      .then((response) => response.json())
      .then((data) => {
        this.countryFromIp= data.address.country;
        this.stateFromIp= data.address.state ;
        this.setCountryAndState(this.countryFromIp,this.stateFromIp);
      })
      .catch((error) => {
        console.error("Error fetching location:", error);
        this.countryFromIp= "";
        this.stateFromIp="" ;
      });
      },
      (error) => console.error("Geolocation error:", error)
    );
  }
  }

  setCountryAndState(_country: any,_state:any){
    if( _country==this.countryFromIp && _state==this.stateFromIp){ 
    this.enquiryForm?.get('country')?.patchValue(this.countryFromIp);
    this.enquiryForm?.get('state')?.patchValue(this.stateFromIp);
    } 

  }

    getCountryCodes(): void { 
      this.authService.getCountrycodes(0, 300).subscribe(
        (response: { data: any[]; }) => {
          this.countryCodes = response.data;
          this.filteredCountryCodes = this.countryCodes;
        },
        (error: any) => {
        }
      );
    }
    
    updatePhoneCode(event: Event): void {
      const selectElement = event.target as HTMLSelectElement;
      const selectedCountryCode = selectElement.value;
      const selectedCode = this.countryCodes.find(code => code.countryCode === selectedCountryCode);
      if (selectedCode) {
        this.enquiryForm.patchValue({
          phoneCode: selectedCode.phoneCode
        });
      }
    }
    
    handleCountry(e: any){
      this.customCountry = e.target.value;
      this.loadCountries(this.customCountry);
    }

    loadCountries(customCountry: string){
      this.masterDataService.getCountries(0, 200, customCountry).subscribe((res: any) => {
        this.countries = res.data;        
      })
    }
    
  initializeenquiryFrom(){    
    this.enquiryForm = this.fb.group({
      firstName: new FormControl('', [Validators.required]),
      lastName: new FormControl('', [Validators.required]),
      email: ['', [Validators.required, Validators.pattern('^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+.[a-zA-Z0-9-.]+$')]],
      phoneCode: new FormControl('', [Validators.required, Validators.pattern("^([+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\./0-9]*$)")]),
      phone: ['', [Validators.required, Validators.minLength(10), Validators.maxLength(15), Validators.pattern("^[0-9]+$")]],
      logo: new FormControl(null, []),
      productId: new FormControl(null, []),
      message: new FormControl(null, [Validators.required]),
      attachments: new FormControl(['']),
      country:new FormControl('',[Validators.required]),
      state:new FormControl('',[Validators.required]),
    })
  }

    initializeEnquiryForm(productInfo: Product) {  
    const firstName = (this.localStorageService.getItem('roleName') === 'DISTRIBUTOR') 
      ? this.userDetailsById?.firstName 
      : (this.userDetailsById?.name.split(' ')[0] || '');
    const lastName = (this.localStorageService.getItem('roleName') === 'DISTRIBUTOR') 
      ? this.userDetailsById?.lastName 
      : (this.userDetailsById?.name.split(' ').slice(1).join(' ') || '');
    const phoneNumber = (localStorage.getItem('roleName') === 'OEM' || this.localStorageService.getItem('roleName') == 'DISTRIBUTOR') 
      ? this.userDetailsById.phoneNumber 
      : this.userDetailsById.phone;
    const phoneCode = this.userDetailsById.phoneCode;
    const email = this.userDetailsById.email;
    const country=this.userDetailsById.country;
    const state=this.userDetailsById.state;

     this.userDetails = JSON.parse(localStorage.getItem('userDetails') as string)
              
    this.enquiryForm = this.fb.group({
      firstName: new FormControl( firstName || '', [Validators.required]),
      lastName: new FormControl( lastName || '', [Validators.required]),      
      email: [email || '', [Validators.required, Validators.pattern('^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+.[a-zA-Z0-9-.]+$')]],
      phoneCode: new FormControl(phoneCode, [Validators.required]),
      phone: [phoneNumber, [Validators.required, Validators.minLength(5), Validators.maxLength(15), Validators.pattern("^[0-9]+$")]],
      productId: new FormControl(productInfo?.id, []),
      message: new FormControl(null, [Validators.required]),
      attachments: new FormControl(['']),
      country:new FormControl(country ||'',[Validators.required]),
      state:new FormControl(state || '',[Validators.required]),
    })
  }

  productInfoById(id: string) {
    this.productsService.getProductDetails(id).subscribe((productData: ApiResponseModel<any>) => {
      this.prodData = productData.data.productInfoDTO
      this.oemData = productData.data;
      if (productData && productData.data) {
        this.receiver1Id = productData?.data?.productInfoDTO?.oemId;
        this.receiver2Id = null;
        this.allDistributorIdofProduct= productData?.data?.productInfoDTO?.distributorsId;
        this.initializeEnquiryForm(productData.data);
      }
    });
  }

  
  fileName = '';
  currentFile?: File;
  selectedFileName: string | null = null;
  imageURL: any;

  selectFile(event: any, isDragAndDrop: boolean): void {
    event.preventDefault();
    const file: File = (isDragAndDrop)? event.dataTransfer.files[0] : event.target.files[0];
    if(file) {
      this.currentFile = file;
      this.fileName = this.getFileNameFromUrl(file.name); 
      this.selectedFileName = this.fileName;
      this.imageURL= this.uploadFile(this.currentFile).subscribe(
    )
    }
}

onDragOver(event: DragEvent) {
  event.preventDefault();
  event.stopPropagation();
}

private uploadFile(file: File): Observable<string> {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('destinationKey', '/subscriptions/');
  return this.fileUploadService.uploadFile(formData).pipe(
    map((response: any) => {
      if (response && response.data) {
        this.imageURL = response.data;
       
        this.selectedFile = true;
        
        return response.data;
      } else {
        throw new Error('Invalid response format from server.');
      }
    })
  );
}

private getFileNameFromUrl(url: string): string {
  return url.split('/').pop() || ''; 
}

  uploadLogo(file: File) {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('destinationKey', '/subscriptions/');
    return this.fileUploadService.uploadFile(formData).pipe(
      map((response: any) => {
       
        
        if (response && response.data) {
          this.imageURL = response.data;
          return response.data;
        } else {
          throw new Error('Invalid response format from server.');
        }
      })
    );
  }

  removeFile(event: any) {
    this.selectedFile = false;
    this.imageURL = '';
    const fileInput = document.getElementById('upload') as HTMLInputElement;
    if (fileInput) {
      fileInput.value = '';
    }
  }

  checkMessageLength() {
    const message = this.enquiryForm.get('message')?.value || '';
    this.messageTooLong = message.length > 250;
  }
  save() {
    const activeSection = document.activeElement as HTMLElement;
    if (activeSection) {
      activeSection.blur(); 
    }
  
    this.messageTooLong = false;
    this.searchControl.setValue('');
    if(!this.id){
      Swal.fire({
        title: 'Enquiry Restricted!!',
        text: "Please login to send an Enquiry!",
        icon: 'error',
        confirmButtonText: 'Ok',
        confirmButtonColor : '#0f74a9',
        allowOutsideClick: false,
      });
      return;
    }
    this.enquiryForm.markAllAsTouched();
    let req: any = JSON.parse(JSON.stringify(this.enquiryForm.value));  
    const proceedWithEnquiry = (filteredIds: string[]) => {
    const reqObj = {
      enqCustomerName: req.firstName + req.lastName,
      email: req.email,
      phone: req.phone,
      senderId: this.id,
      productInfoId: this.productId,
      receiver1Id: this.receiver1Id,
      receiver2Id: null,
      distributorIds:filteredIds,
      message: req.message,
      isGroup:true,
      receiverId: this.id ? [this.receiver1Id, this.id] : [this.receiver1Id],
      enquiryType: 'PRODUCT',
      attachments:(typeof this.imageURL === 'string') ? ([this.imageURL]) : (null),
      country:req.country,
      state:req.state
    };
    if (req.firstName && req.lastName && req.email && req.phone && req.country && req.state) {
      this.oemService.saveEnquiry(reqObj).subscribe(
        (response) => {
          this.enquiryForm.reset();
          this.sweetAlertService.showSuccess('', 'Enquiry Submitted Successfully !!');
        },
        (error) => {
          this.sweetAlertService.showError('', 'Failed to Submit Enquiry !!');
        }
      );
      this.enquiryForm.reset();
      this.selectedFile = false;
      this.imageURL = '';
      this.country ='';
      this.state= '';
      this.enquiryForm.get('phoneCode')?.setValue('');
      this.filteredCountryCodes = this.countryCodes;
    } else {
      this.sweetAlertService.showWarning('', 'Please fill all the required fields');
    }
  };
  if (this.allDistributorIdofProduct && this.allDistributorIdofProduct.length > 0 && !this.allDistributorIdofProduct.includes(null)) {
    const distributorObservables = this.allDistributorIdofProduct.map((id: string) =>
      this.distributorService.getDistributorById(id)
    );
  
     forkJoin(distributorObservables).subscribe({
       next: (results: any) => {
         this.filteredDistributorIds = this.allDistributorIdofProduct.filter((id: string, index: number) => {
           const res = results[index];
           return res.data && res.data.state === req.state;
         });
         proceedWithEnquiry(this.filteredDistributorIds);
        },
        error: (err) => {
          console.error('Error fetching distributor data:', err);
          proceedWithEnquiry([]);
        }
      });
    } else {
      proceedWithEnquiry([]);
    }
  }

  cancel() {
    window.history.back();
  }

  areAllPropertiesNull(obj: any): boolean {
    for (const key in obj) {
      if (!(obj[key] === null || obj[key] === '')) {
        return false;
      }
    }
    return true;
  }

  sendMessage(message: any): void {
    this.websocketService.sendMessage(message);
  }

  concatCountryCodeAndPhone(): string {
    const phoneCode = this.enquiryForm.get('phoneCode')?.value || '';
    const phone = this.enquiryForm.get('phone')?.value || '';
    return `${phoneCode}${phone}`;
  }

  get f() { return this.enquiryForm.controls; }

  get phone() {
    return this.enquiryForm.get('phone');
  }

  get isPhoneInvalid() {
    return this.enquiryForm.get('phone')?.invalid && (this.enquiryForm.get('phone')?.dirty || this.enquiryForm.get('phone')?.touched);
  }

  showDropdownList(): void {
    this.filteredCountryCodes = this.countryCodes;
    this.showDropdown = true;
  }
  
  filterCountryCodes(term: string): void {
    this.filteredCountryCodes = term ? 
      this.countryCodes.filter(code =>
        code.countryCode.toLowerCase().includes(term.toLowerCase())
      ) 
      : this.countryCodes; 
  }
  
  hideDropdown(): void {
    setTimeout(() => this.showDropdown = false, 200);
  }
  
  selectCountryCode(code: { countryCode: string; phoneCode: string }): void {
    this.enquiryForm.patchValue({
      countryCode: code.countryCode,
      phoneCode: code.phoneCode
    });
    this.searchControl.setValue(code.countryCode);
    this.showDropdown = false; 
  }

  getUserDetailsById(user:any) {
    user.subscribe((res: any) => {
      if (res) {
        this.userDetailsById = res.data;
        this.productInfoById(this.productId);
      }
    });
  }
  preventNumericInput(event: KeyboardEvent, geographyName: any): void {
    const charCode = event.charCode || event.keyCode;
    if (charCode >= 48 && charCode <= 57) {
      event.preventDefault();
    }
    
    const inputChar = event.key;
    let currentValue='';
    if(geographyName === 'country') {
       currentValue = this.country|| '';
    } else if (geographyName === 'state') {
       currentValue = this.state || '';
    } 
    
    if ((currentValue.length === 0 && inputChar === ' ') || currentValue[0] === ' ' || currentValue[0] === ' ' && inputChar === ' ') {
        event.preventDefault();
    }
  }

  
}